import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { useParams, useNavigate } from "react-router-dom";
import { axiosPrivate, axiosQuick, axiosWithoutHeader } from "../api/axios";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Grid,
  Container,
  Typography,
  Tooltip,
} from "@mui/material";
import Header from "./shared/header";
import { MuiTelInput ,matchIsValidTel} from "mui-tel-input";
import loader from "../utils/Helper";
import { categoryList } from "../data/categories";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from "@mui/material/Slide";

const GET_USER = "/account";
const UPDATE_USER = "/account/updateProfile";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const UserProfile = ({ isAdmin = false }) => {
  const initialValues = isAdmin
    ? {
        referenceName: "",
        email: "",
        phone: "",
        receiveWhatsappNotifications: false,
        whatsAppPhone: "",
        phoneinfo:null,
        whatsappInfo:null
      }
    : {
        departmentName: "",
        referenceName: "",
        email: "",
        phone: "",
        companyName: "",
        pan: "",
        streetAddress: "",
        receiveWhatsappNotifications: false,
        whatsAppPhone: "",
        phoneinfo:null,
        whatsappInfo:null
      };
  const toast = useRef(null);
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user"));
  const [originalData, setoriginalData] = useState({});
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState(false);
  const [message, setMessage] = useState(false);
  const [alertWidth, setAlertWidth] = useState("100%");
  const phoneRef = useRef();
  const validate = (values) => {
    const errors = {};
  
  
    if (values.referenceName && values.referenceName.length < 2) {
      errors.referenceName = "Name must be longer than 1 character";
    }
  
    if (!values.email) {
      errors.email = "Please enter your email";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = "Please enter a valid email address";
    }
  
    if (!values.phone) {
      errors.phone = "Please enter your phone number";
    } 
    else if( values.phoneinfo && !values.phoneinfo.nationalNumber.length){
      errors.phone = "Please enter your phone number";
    }
   
  
    if (values.receiveWhatsappNotifications ) {
      if (!values.whatsAppPhone) {
        errors.whatsAppPhone = "Please enter your WhatsApp number";
      } else if (values.whatsappInfo && !values.whatsappInfo.nationalNumber.length) {
        errors.whatsAppPhone = "Please enter your WhatsApp number";;
      }
    }
  
    return errors;
  };
  useEffect(() => {
    loader.isLoading(true);
    getUser();
  }, []);
  const updateUser = async (values) => {
    try {
      loader.isLoading(true);
      const response = await axiosWithoutHeader.post(
        UPDATE_USER,
        formik.values
      );
      if (response.status === 200) {
        setOpen(true);
        setSeverity('success');
        setAlertWidth("100%");
        setMessage(response.data.error);
        getUser(true);

        if (
          values.whatsAppPhone !== originalData.whatsAppPhone &&
          values.receiveWhatsappNotifications 
        ) {
          const WhatsAppMessage =
            "Thank you for opting to receive future account updates through WhatsApp notifications from Team: ClearrMyNotice. \n If you have any questions or need assistance, feel free to ask.";
          setOpen(true);
          setSeverity('success');
          setAlertWidth("40%");
          setMessage(WhatsAppMessage);
        }
      }
    } catch (err) {
      setOpen(true);
      setSeverity('error');
        setAlertWidth("100%");
      setMessage(err.response.data.message);
    } finally {
      loader.isLoading(false);
    }
  };
  const formik = useFormik({
    initialValues,
    validate,
    onSubmit: updateUser,
    validateOnBlur: true, // Disable onBlur validation
    validateOnChange: true, // Disable onChange validation
  });
  const updateLocalStorage = (newData = {}) => {
    const updatedUserData = {
      email: newData.email,
      firstName: newData.referenceName,
      id: newData.id,
      isProfileComplete:newData.isProfileComplete
    };

    const userData = JSON.parse(localStorage.getItem("user"));
    const updatedData = { ...userData, ...updatedUserData };

    // Store the updated data back in localStorage
    localStorage.setItem("user", JSON.stringify(updatedData));
  };
  const getUser = async (update = false) => {
    try {
      loader.isLoading(true);
      const response = await axiosQuick.get(`${GET_USER}/${userData.id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.jwtToken}`,
        },
      });

      const departmentList = categoryBodyTemplate(response.data.categoryId);
      if (response.status == 200) {
        const profiledata = isAdmin
          ? {
              referenceName: response.data.referenceName,
              email: response.data.email,
              phone: response.data.phone,
              receiveWhatsappNotifications: response.data.whatsAppPhone
                ? true
                : false,
              whatsAppPhone: response.data.whatsAppPhone,
              accountId: response.data.id,
              categoryId: response.data.categoryId,
            }
          : {
              referenceName: response.data.referenceName,
              email: response.data.email,
              phone: response.data.phone,
              companyName: response.data.companyName,
              pan: response.data.pan,
              streetAddress: response.data.streetAddress,
              receiveWhatsappNotifications: response.data.whatsAppPhone
                ? true
                : false,
              whatsAppPhone: response.data.whatsAppPhone,
              accountId: response.data.id,
              categoryId: response.data.categoryId,
              departmentName: departmentList,
            };

        update && updateLocalStorage(response.data);
        formik.setValues({ ...profiledata });
        setoriginalData(profiledata);
      }

      // Process response or perform other tasks
    } catch (error) {
      // Handle error here
      console.error("Error fetching user:", error);
      setOpen(true);
      setSeverity('error');
      setAlertWidth("100%");
      setMessage(error.response.data.message);
    } finally {
      loader.isLoading(false);
    }
  };
  const categoryBodyTemplate = (ids) => {
    const selectedCategories = [];
    for (const id of ids) {
      const category = categoryList.find((item) => item.id === id);
      if (category) {
        selectedCategories.push(category.category);
      }
    }
    return selectedCategories.join("\n");
  };

    const handleClose = async () => {
    setOpen(false);
  };


  return (
    <>
      <Snackbar
    open={open}
    autoHideDuration={5000}
    onClose={handleClose}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
    TransitionComponent={SlideTransition}
    >
    <Alert
        onClose={handleClose}
        severity= {severity}
        variant="filled"
        sx={{ width: alertWidth }}
    >
        {message}
    </Alert>
</Snackbar>
      <Header />
      <Container>
        <Typography variant="h5" style={{ margin: "20px 0px" }}>
          {userData.isSuperAdmin
            ? "Admin Profile"
            : userData.isAdmin
            ? "Consultant Profile"
            : "User Profile"}
        </Typography>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item sm={6} xs={12}>
              <TextField
                label=" Name"
                fullWidth
                autoFocus
                id="referenceName"
                variant="outlined"
                className="custom-inputField"
                value={formik.values.referenceName || ""}
                onChange={formik.handleChange}
                error={
                  formik.touched.referenceName && !!formik.errors.referenceName
                }
                helperText={
                  formik.touched.referenceName && formik.errors.referenceName
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                label="Email"
                fullWidth
                id="email"
                disabled={true}
                variant="outlined"
                className="custom-inputField"
                value={formik.values.email || ""}
                onChange={formik.handleChange}
                error={formik.touched.email && !!formik.errors.email}
                helperText={formik.touched.email && formik.errors.email}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <MuiTelInput
                forceCallingCode
                className="custom-inputField "
                label="Phone Number"
                fullWidth
             
                defaultCountry="IN"
                value={formik.values.phone}
                onChange={(value,info) =>{
                  formik.setValues({
                        ...formik.values,
                    phoneinfo: info,
                    phone: value.replace(/\s+/g, "")
                  });
                }
                
                }
                onBlur={formik.handleBlur("phone")}
                error={Boolean(formik.errors.phone)}
                helperText={formik.errors.phone}
              />
            </Grid>
          
            {!isAdmin && (
              <Grid item sm={6} xs={12}>
                {" "}
                <TextField
                  label="Organization Name"
                  fullWidth
                  id="companyName"
                  className="custom-inputField"
                  variant="outlined"
                  value={formik.values.companyName || ""}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.companyName && !!formik.errors.companyName
                  }
                  helperText={
                    formik.touched.companyName && formik.errors.companyName
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}
            {!isAdmin && (
              <Grid item sm={6} xs={12}>
                {" "}
                <TextField
                  label="PAN"
                  fullWidth
                  id="pan"
                  variant="outlined"
                  className="custom-inputField"
                  value={formik.values.pan || ""}
                  onChange={formik.handleChange}
                  error={formik.touched.pan && !!formik.errors.pan}
                  helperText={formik.touched.pan && formik.errors.pan}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}
            {!isAdmin && (
              <Grid item sm={6} xs={12}>
                {" "}
                <TextField
                  label="Street Address"
                  fullWidth
                  id="streetAddress"
                  className="custom-inputField"
                  variant="outlined"
                  value={formik.values.streetAddress || ""}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.streetAddress &&
                    !!formik.errors.streetAddress
                  }
                  helperText={
                    formik.touched.streetAddress && formik.errors.streetAddress
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}
              {userData.isAdmin &&    <Grid item sm={6} xs={12}>
             
          
               <TextField
                 label="Department Name"
                 fullWidth
                 disabled={true}
                 id="DepartmentName"
                 className="custom-inputField"
                 variant="outlined"
                 multiline
                 value={formik.values.departmentName || ""}
                 onChange={formik.handleChange}
                 error={
                   formik.touched.departmentName &&
                   !!formik.errors.departmentName
                 }
                 helperText={
                   formik.touched.departmentName &&
                   formik.errors.departmentName
                 }
                 InputLabelProps={{
                   shrink: true,
                 }}
               />
       
         
         </Grid>
           }
            <Grid item sm={6} xs={12}>
              {(formik.values.receiveWhatsappNotifications || userData.isAdmin) && (
                <MuiTelInput
                  forceCallingCode
                  className="custom-inputField "
                  label="WhatsApp Number"
                  fullWidth
                  defaultCountry="IN"
                  value={formik.values.whatsAppPhone || ""}
                  onChange={(value,info) =>{
                    formik.setValues({
                      ...formik.values,
                      whatsappInfo: info,
                      whatsAppPhone: value.replace(/\s+/g, "")
                    });
                  }
                    
                  }
                  inputRef={phoneRef}
                  autoFocus={
                    formik.touched.receiveWhatsappNotifications &&
                    formik.values.receiveWhatsappNotifications
                  }
                  onBlur={formik.handleBlur("whatsAppPhone")}
                  error={Boolean(formik.errors.whatsAppPhone)}
                  helperText={formik.errors.whatsAppPhone}
                />
              )}
              {!userData.isAdmin && (
                <FormControlLabel
                  control={
                    <Checkbox
                      id="receiveWhatsappNotifications"
                      checked={formik.values.receiveWhatsappNotifications}
                      onChange={(e) => {
                        const value = e.target.checked;
                        if (value == false) {
                          formik.setValues({
                            ...formik.values,
                            receiveWhatsappNotifications: value,
                            whatsAppPhone: null,
                          });
                        } else {
                          formik.setValues({
                            ...formik.values,
                            receiveWhatsappNotifications: value,
                            whatsAppPhone:
                              originalData.whatsAppPhone || formik.values.phone,
                          });
                        }
                      }}
                      name="receiveWhatsappNotifications"
                    />
                  }
                  label="Receive WhatsApp Notifications"
                />
              )}
            </Grid>
          </Grid>

          <Grid item xs={12} marginTop={"20px"}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className="p-button p-component p-button-success btn-h submitbutton"
              style={{ width: "120px" }}
            >
              Submit
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="btn btn-h cancelbutton"
              style={{
                marginLeft: "10px",

                width: "120px",
              }}
              onClick={() => {
                formik.setValues({ ...originalData });
                navigate("/dashboard");
              }}
            >
              Cancel
            </Button>
          </Grid>
        </form>
      </Container>
    </>
  );
};

export default UserProfile;
